/* ==========================================================================
SIGN UP
========================================================================== */

jQuery(function ($) {
    //EMAIL SIGNUP
    var $emailSubmit = $('#emailSubmit');
    var $mailChimpSubmit = $('#mc-embedded-subscribe');

    var $fname = $('#fname');
    var $sname = $('#sname');
    var $emailContact = $('#email');
    var $errorResponse = $('#errorResponse');
    var error = false;

    $emailSubmit.click(function(e) { 
        e.preventDefault(); 
        
        error = false;      
        var emailVal = $emailContact.val();
        if ($fname.val() == 'First Name') {
            error = true;
            $fname.focus();
            $errorResponse.css('display', 'block').text('Please enter your first name');
        }
        
        if ( (error === false) && ($sname.val() == 'Last Name') ) {
            error = true;
            $sname.focus();
            $errorResponse.css('display', 'block').text('Please enter your surname');
        }
        
        if ( (error === false) && ($emailContact.val() == 'EMAIL ADDRESS')) {
            error = true;
            $emailContact.focus();
            $errorResponse.css('display', 'block').text('Please enter your email address');
        }       
                            
        if ( (error === false) && (validateEmail(emailVal) === false) ) {
            error = true;
            $emailContact.focus();
            $errorResponse.css('display', 'block').text('Please enter a valid email address');
        }
        
        if ( (error === false) && (!document.getElementById('mce-group[19041]-19041-0').checked) ) {
            error = true;           
            $errorResponse.css('display', 'block').text('Please agree to our privacy policy');
        }       
        
        if (error === false) {
            $('#mce-success-response').css('display', 'block').text('SUBMITTING...');
            $errorResponse.css('display', 'none');
            $mailChimpSubmit.click();
        }
    });

    function validateEmail(email) {
        var re = /[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4}/igm;
        if (email == '' || !re.test(email)) {
            return false;
        } else {
            return true;
        }   
    }
});